interface RecommendationCapsuleProps {
  onSelect: (text: string) => void;
}

const RECOMMENDATIONS = [
  { id: 1, text: '最近一周的门票销售趋势如何?', icon: 'ri-line-chart-line' },
  { id: 2, text: '哪个景点的游客满意度最高?', icon: 'ri-star-line' },
  { id: 3, text: '预测下个月的客流量峰值', icon: 'ri-trending-up-line' },
  { id: 4, text: '对比不同渠道的转化率', icon: 'ri-pie-chart-line' },
  { id: 5, text: '分析游客的年龄分布情况', icon: 'ri-group-line' },
  { id: 6, text: '统计热门时段的客流量', icon: 'ri-time-line' },
];

export default function RecommendationCapsule({ onSelect }: RecommendationCapsuleProps) {
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-2">
        <i className="ri-lightbulb-line text-blue-600 text-sm"></i>
        <span className="text-xs font-medium text-gray-700">推荐问题</span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {RECOMMENDATIONS.map((item) => (
          <button
            key={item.id}
            onClick={() => onSelect(item.text)}
            className="px-2.5 py-1.5 bg-white border border-gray-200 rounded-full text-xs text-gray-700 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-700 transition-all cursor-pointer whitespace-nowrap"
          >
            {item.text}
          </button>
        ))}
      </div>
    </div>
  );
}
